import React from 'react';
import './RatingSummary.scss';

export const RatingNumber = ({ rating }: { rating: number }) => {
    const croppedRating = Number(rating)?.toFixed(1);
    return <h3 className="rating-number eds-text-hs">{croppedRating}</h3>;
};
